import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { RootState } from '../../app/store';
import { QuestionParsed } from '../../types/certifications/Certification';
import { ExamGuardState } from './guard/types';

interface ExamState {
  questions: QuestionParsed[];
  guards: Record<string, ExamGuardState>;
}

interface SetQuestionsPayload {
  questions: QuestionParsed[];
}

const initialState = {
  questions: [] as QuestionParsed[],
  guards: {},
} as ExamState;

const examSlice = createSlice({
  name: 'exam',
  initialState,
  reducers: {
    setQuestions: (
      state: ExamState,
      action: PayloadAction<SetQuestionsPayload>,
    ) => {
      const { questions } = action.payload;

      state.questions = questions;
    },
    setGuardState: (
      state: ExamState,
      action: PayloadAction<ExamGuardState>,
    ) => {
      state.guards[action.payload.certificationLogId] = action.payload;
    },
    clearGuardState: (state: ExamState, action: PayloadAction<string>) => {
      delete state.guards[action.payload];
    },
  },
});

export const { setQuestions, setGuardState, clearGuardState } =
  examSlice.actions;

export default examSlice.reducer;

export const selectQuestion = (state: RootState) => state.exam.questions;
export const selectExamGuard = (state: RootState, certificationLogId: string) =>
  state.exam.guards[certificationLogId];
